const sum = (...values) =>
    values.reduce((total, value) => total + Number(value || 0), 0);

const measured = (id, name, connected, value) => ({
    id,
    name,
    value: connected ? value : null,
    connected: Boolean(connected),
});

export const buildOperationalIssueSeries = (overview = {}) => {
    const places = overview.operations?.places || {};
    const content = overview.operations?.content || {};
    const notifications = overview.operations?.notifications || {};
    const settlements = overview.settlements || {};

    return [
        measured("places", "Заведения", places.connected, sum(
            places.missingLegal,
            places.missingMedia,
            places.branchesWithoutGallery,
            places.branchesWithoutStaff,
        )),
        measured("content", "Контент", content.connected, sum(
            content.bannersWithoutContent,
            content.storiesWithoutPreview,
            content.storiesWithoutItems,
        )),
        measured("inbox", "Входящие", notifications.connected, sum(
            notifications.pendingCount,
            notifications.changedCount,
            notifications.rejectedCount,
        )),
        measured("settlements", "Взаиморасчеты", settlements.connected, Number(settlements.draftCount || 0)),
    ];
};
